const RANDOM_SYMBOLS = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  // medium difficulty symbols
  "#",
  "%",
  "&",
  "<",
  ">",
  "=",
  "@",
];

export default function createTableType2(
  text: string,
  size: [number, number],
  difficulty: "easy" | "medium",
): string[][] {
  const [rows, columns] = size;
  const cellCount = rows * columns;

  const letters = text
    .toUpperCase()
    .replace(/\s+/g, "")
    .split("");

  if (letters.length > cellCount) {
    throw new Error("Текст не помещается в таблицу");
  }

  const randomSymbols =
    difficulty === "easy"
      ? RANDOM_SYMBOLS.slice(0, 10)
      : RANDOM_SYMBOLS;

  const result = Array(cellCount);

  const gaps = letters.length + 1;

  const availableCells = cellCount - letters.length;

  const baseGap = Math.floor(availableCells / gaps);
  const extraGaps = availableCells % gaps;

  let position = baseGap;

  for (let i = 0; i < letters.length; i++) {
    const randomOffset = Math.floor(Math.random() * 3) - 1;

    position += randomOffset;


    position = Math.max(
      i + 1,
      Math.min(
        cellCount - (letters.length - i),
        position,
      ),
    );

    result[position] = letters[i];

    position += baseGap + 1;

    if (i < extraGaps) {
      position++;
    }
  }

  for (let i = 0; i < cellCount; i++) {
    if (!result[i]) {
      result[i] =
        randomSymbols[
          Math.floor(Math.random() * randomSymbols.length)
        ];
    }
  }

  const table: string[][] = [];

  for (let row = 0; row < rows; row++) {
    table.push(
      result.slice(row * columns, (row + 1) * columns),
    );
  }

  return table;
}